import { h } from 'preact'
import clsx from 'clsx'

interface BadgeData {
  title: string
  text_colour: string
  background_colour?: string
  image?: string
  off_messaging?: string[]
}

interface BadgeProps {
  badge: BadgeData
  badgeLocation?: string
  product?: any
}

const TextBadge = ({ badge, badgeLocation, product }: { badge: BadgeData; badgeLocation?: string; product?: any }) => {
  let showOffMessaging = false
  let salePercentage = 0

  if (product && product.variants && product.variants[0]) {
    const variant = product.variants[0]
    const offMessagingString = badge.off_messaging?.join(',') || ''

    if (variant.compare_at_price && variant.compare_at_price !== variant.price) {
      if (badgeLocation === 'PLP' && offMessagingString.includes('PLP')) {
        showOffMessaging = true
      } else if (badgeLocation === 'PDP' && offMessagingString.includes('PDP')) {
        showOffMessaging = true
      }

      if (showOffMessaging) {
        salePercentage = Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
      }
    }
  }

  return (
    <div
      className={clsx('shrink-0 flex size-fit text-[--text-colour] bg-[--bg-colour] md-max:max-w-[70px]', {
        'px-0.5 py-0.25 rounded-badge overflow-hidden': badge.background_colour
      })}
      style={{
        '--text-colour': badge.text_colour,
        '--bg-colour': badge.background_colour || 'transparent'
      } as React.CSSProperties}
    >
      <span className="paragraph-2xs md:paragraph-xs font-heading-spaced uppercase">
        {badge.title}
        {showOffMessaging && `${badge.title ? ' | ' : ''}-${salePercentage}%`}
      </span>
    </div>
  )
}

const ImageBadge = ({ badge }: { badge: BadgeData }) => (
  <div className="flex size-fit max-w-[75px] children:size-auto children:size-contain">
    <img src={badge.image} alt={badge.title || 'Badge'} />
  </div>
)

export const Badge = ({ badge, badgeLocation, product }: BadgeProps) => {
  if (!badge) return null

  return badge.image ? <ImageBadge badge={badge} /> : <TextBadge badge={badge} badgeLocation={badgeLocation} product={product} />
}
